
  <ng-container *ngIf="!field.templateOptions.hidden">
  <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
      <formly-form
        [form]="form"
        [fields]="fields"
        [model]="model"
      ></formly-form>
      <!-- <button type="submit" class="btn btn-default" [disabled]="!form.valid">Submit</button> -->
    </form>
  </ng-container>
    <!-- <input type="input" [formControl]="formControl" [formlyAttributes]="field"> -->
    <!-- <button
      type="submit"
      class="{{
        field.templateOptions.className
          ? field.templateOptions.className
          : 'btn btn-default'
      }}"
      [disabled]="field.templateOptions.disabled || form.invalid"
    >
      {{ field.templateOptions.buttonLabel }}
    </button> -->
    <!-- {{ field.templateOptions.disabled}} -->
  